query LabelSearch($contentId: ID, $searchText: String!) {
  labelSearch(contentId: $contentId, searchText: $searchText) {
    suggestedLabels {
      name
    }
    otherLabels {
      name
    }
  }
}
